import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, CircularProgress, Typography
} from '@mui/material';

export function PreviewImagesDialog({
  open,
  loading,
  images,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>圖片</DialogTitle>

      <DialogContent>
        {loading ? (
          <Box sx={{ py: 4, textAlign: 'center' }}>
            <CircularProgress />
          </Box>
        ) : images.length === 0 ? (
          <Typography sx={{ py: 2 }}>沒有上載圖片</Typography>
        ) : (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
            {images.map((img) => (
              <Box key={img.id} sx={{ width: 160 }}>
                <img
                  src={img.url || img.file_url}
                  alt={img.file_name}
                  style={{ width: "100%", borderRadius: 4 }}
                />
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>關閉</Button>
      </DialogActions>
    </Dialog>
  );
}
